import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
const links = ['Inicio', 'Proyectos', 'Servicios', 'Mi equipo', 'Proceso', 'Sobre mí', 'Contacto'];
const anchors = ['inicio', 'proyectos', 'servicios', 'equipo', 'proceso', 'sobre-mi', 'contacto'];
export function Navigation() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 32);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <header className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${scrolled || open ? 'bg-[#f7f4ef]/95 shadow-sm backdrop-blur-md' : 'bg-transparent'}`} data-id="element-122">
      <nav className="mx-auto flex h-20 max-w-[1440px] items-center justify-between px-5 md:px-10" data-id="element-123">
        <a href="#inicio" className={`font-editorial text-xl tracking-tight ${scrolled || open ? 'text-[#1A1A1A]' : 'text-white'}`} data-id="element-124">
          María Victoria <span className="italic" data-id="element-125">Corbalan</span>
        </a>
        <div className={`hidden items-center gap-6 text-[11px] font-semibold uppercase tracking-[.13em] lg:flex ${scrolled ? 'text-[#1A1A1A]' : 'text-white'}`} data-id="element-126">
          {links.map((link, i) => <a className="transition-colors hover:text-[#C4724A]" key={link} href={`#${anchors[i]}`} data-id="element-127">
              {link}
            </a>)}
        </div>
        <a href="#contacto" className={`hidden border px-5 py-2.5 text-[11px] font-bold uppercase tracking-wider transition-colors md:block ${scrolled ? 'border-[#1A1A1A] hover:bg-[#1A1A1A] hover:text-white' : 'border-white text-white hover:bg-white hover:text-[#1A1A1A]'}`} data-id="element-128">
          Hablemos
        </a>
        <button aria-label={open ? 'Cerrar menú' : 'Abrir menú'} className={`p-2 lg:hidden ${scrolled || open ? 'text-[#1A1A1A]' : 'text-white'}`} onClick={() => setOpen(!open)} data-id="element-129">
          {open ? <XIcon size={24} data-id="element-130" /> : <MenuIcon size={24} data-id="element-131" />}
        </button>
      </nav>
      {open && <div className="border-t border-[#ded7ce] bg-[#F7F4EF] px-5 py-6 lg:hidden" data-id="element-132">
          <div className="flex flex-col gap-5 text-sm font-semibold" data-id="element-133">
            {links.map((link, i) => <a onClick={() => setOpen(false)} key={link} href={`#${anchors[i]}`} data-id="element-134">
                {link}
              </a>)}
            <a onClick={() => setOpen(false)} href="#contacto" className="mt-1 w-fit bg-[#C4724A] px-5 py-3 text-xs font-bold uppercase tracking-wider text-white" data-id="element-135">
              Hablemos
            </a>
          </div>
        </div>}
    </header>;
}